<template>    
    <div class="container">
        <VUEConfirm :Popup="PopupEliminaSito" :Richiesta="DescrizionePopup" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'" @OnClickConfermaPopup="ConfermaElimina()" @OnClickChiudiPopup="AnnullaElimina()">
        </VUEConfirm>
        <div class="row">
          <div class="block">
            <div class="header" style="padding:0px"> 
              <div class="block block-transparent nm">
                <div class="content controls">
                  <div class="form-row">                        
                    <div class="col-md-3" style="padding-left:0px">
                      <div class="input-group">
                        <div class="input-group-addon"><span class="fa fa-search"></span></div>
                        <input type="text" class="form-control" :placeholder="this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_CERCA_SITO',this.LinguaUtente)" v-model="Filtri.Nome"/>
                      </div>
                    </div>
                    <div class="col-md-2" style="padding-left:0px; margin-left: 10px">
                      <select class="form-control" v-model="Filtri.Abilitati">
                        <option value="-1">{{ this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_APP_CON_GEST_SIT_ABIL_NO_ABIL',this.LinguaUtente) }}</option>
                        <option value="1">{{ this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_APP_CON_GEST_SIT_ABIL',this.LinguaUtente) }}</option>
                        <option value="0">{{ this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_APP_CON_GEST_SIT_NO_ABIL',this.LinguaUtente) }}</option>
                      </select>
                    </div>
                    <div class="col-md-2" v-if="Admin" style="float:right;padding-right:0px;">
                      <button type="button" class="btn btn-success" @click="OnClickApriSito(-1)" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
                    </div>
                    <div class="col-md-2" style="float:right;padding-right:0px;">
                      <button type="button" class="btn btn-info" @click="VisualizzaSiti(1, true)" style="width:100%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_APP_CON_GEST_SIT_FILTRA',this.LinguaUtente) }}</button>
                    </div>                             
                  </div>
                </div>
              </div>                                      
            </div>
            <div class="content">
              <table cellpadding="0" cellspacing="0" width="100%" class="table table-bordered table-striped sortable">
                <thead style="background-color:#60604d;color:white">
                  <tr>
                    <th width="47.5%">{{ this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente) }}</th>
                    <th width="47.5%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_APP_CON_GEST_SIT_ABIL',this.LinguaUtente) }}</th>
                    <th width="5%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_APP_CON_GEST_SIT_AZIONI',this.LinguaUtente) }}</th>
                  </tr>
                </thead>
                <tbody :style="{'background-color' : Arancione}">
                  <tr v-for="sito in Siti" :Key="sito.CHIAVE">
                    <td style="vertical-align:middle">{{sito.NOME}}</td>
                    <td style="vertical-align:middle">{{sito.ABILITATO == 'T' ? 'Sì' : 'No'}}</td>
                    <td style="vertical-align:middle">
                      <i class="fa fa-pencil ZMIconButton" @click="OnClickApriSito(sito.CHIAVE)" :style="GetStyleAzioni()"></i>
                      <i class="fa fa-trash-o text-danger ZMIconButton" v-if="Admin" @click="OnClickEliminaSito(sito)"></i>
                    </td>                         
                  </tr>
                </tbody>
                <tfoot>
                  <ul class="pagination" style="margin-top:1px; margin-bottom:5px; margin-top:10px; margin-left:30px">
                    <li><a class="fa fa-backward" style="cursor:pointer" @click="OnClickFirstAndLastPage(1, true)"></a></li>
                    <li><a class="fa fa-chevron-left" style="cursor:pointer" @click="VisualizzaSiti(ObjPagine.Pagina - 1, true)"></a></li>
                    <li v-for="pagina, index in ObjPagine.PagineVisibili" :key="index"><a style="color:white; cursor:pointer" :style="{'background-color' : pagina == ObjPagine.Pagina ? '#F18B53' : '#fabe98'}"  @click="VisualizzaSiti(pagina, true)">{{pagina}}</a></li>
                    <li><a class="fa fa-chevron-right" style="cursor:pointer" @click="VisualizzaSiti(ObjPagine.Pagina + 1, true)"></a></li>
                    <li><a class="fa fa-forward" style="cursor:pointer" @click="OnClickFirstAndLastPage(ObjPagine.NumeroPagine, true)"></a></li>
                  </ul>
                </tfoot>
              </table>                                        
            </div>                          
          </div>               
        </div>
    </div>           
</template>


<script>
import { SystemInformation, RUOLI, SFONDO, COLORI} from '@/SystemInformation.js'
import VUEConfirm from '@/utils/VUEConfirm.vue';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TSchedaGenerica } from '@/utils/ZSchedaGenerica';
import { TemporaryGlobals } from '@/TemporararyGlobal.js'

export default {
    name:'app',
    components: {
                   VUEConfirm
    },
    mixins: [ MixInsGestioneTraduzioni ],
    data()
    {
       return {
                Siti                          : [],
                SitoSelezionato               : {},
                PopupEliminaSito              : false,
                DescrizionePopup              : '',
                LinguaUtente                  : SystemInformation.UserInformation.Lingua,
                Filtri                        : {Nome: '', Abilitati: -1},
                Admin                         : false,
                ObjPagine                     : {
                                                  Pagina            : 1,
                                                  PagineVisibili    : [],
                                                  NumeroPagine      : 0,
                                                  NumeroPerPagina   : 30,
                                                },
                Arancione                     : SFONDO.Arancione,
                Giallo                        : COLORI.Giallo
              }
    },
    methods :
    {
      GetListaSiti(OffsetPagine, AggiornamentoConteggio)
      {
        let Parametri = {}
        Parametri.NumeroPerPagina = this.ObjPagine.NumeroPerPagina        
        Parametri.OffsetPagine = OffsetPagine
        if (this.Filtri.Nome != '')
          Parametri.Nome = '%' + TSchedaGenerica.PrepareForRecordString(this.Filtri.Nome) + '%'
        if (this.Filtri.Abilitati != -1)
          this.Filtri.Abilitati == 0 ? Parametri.Abilitati = 'F' : Parametri.Abilitati = 'T'
        let Self = this
        let Modello   = 'SuperUtente_Siti'
        if (this.Admin)
          Modello   = 'Admin_Siti'
        SystemInformation.AdvQuery.GetSQL(Modello,Parametri,
                                            function(Results)
                                            {
                                              let ArrayInfo = SystemInformation.AdvQuery.FindResults(Results,"Siti")
                                              if(ArrayInfo != undefined)
                                              {
                                                Self.Siti = ArrayInfo
                                                if (AggiornamentoConteggio)
                                                {
                                                  let NumeroSiti = SystemInformation.AdvQuery.FindResults(Results,"NumeroSiti")
                                                  if (NumeroSiti != undefined)
                                                  {
                                                    let NumeroPerPagina = Self.ObjPagine.NumeroPerPagina
                                                    Self.ObjPagine.NumeroPagine = (NumeroSiti[0].NUMERO % NumeroPerPagina) != 0 ? Math.floor(((NumeroSiti[0].NUMERO) / (NumeroPerPagina)) + 1) : Math.floor(((NumeroSiti[0].NUMERO) / (NumeroPerPagina)))
                                                    Self.AggiornamentoPagineVisibili()
                                                  }
                                                }
                                              }
                                              else SystemInformation.HandleError('Errore nel modello siti')
                                            },
                                            SystemInformation.HandleError);   
      },

      VisualizzaSiti(pagina, AggiornamentoConteggio = false)
      {
        if(this.ObjPagine.NumeroPagine == 0 || pagina != 0 && pagina != this.ObjPagine.NumeroPagine+1)
        {
          this.Siti = []
          let OffsetPagine = (this.ObjPagine.NumeroPerPagina * (pagina - 1))
          this.ObjPagine.Pagina = pagina
          this.GetListaSiti(OffsetPagine, AggiornamentoConteggio)
        }
      },

      OnClickFirstAndLastPage(pagina, AggiornamentoConteggio = false)
      {
        this.Siti = []
        let OffsetPagine = (this.ObjPagine.NumeroPerPagina * (pagina - 1))
        this.ObjPagine.Pagina = pagina
        this.GetListaSiti(OffsetPagine, AggiornamentoConteggio) 
      },

      AggiornamentoPagineVisibili()
      {
        let Pagine = this.ObjPagine
        Pagine.PagineVisibili = []
        if (Pagine.NumeroPagine > 2)
        {
          if (Pagine.Pagina > 2)
          {
            if (Pagine.NumeroPagine - Pagine.Pagina >= 1)
            {
              for(let i = -1; i <= 1; i++)
              {
                Pagine.PagineVisibili.push(Pagine.Pagina + i)
              }
            }
            else
            {
              for(let i = -2; i <= 0; i++)
              {
                Pagine.PagineVisibili.push(Pagine.Pagina + i)
              }
            }
          }
          else
          {
            for(let i = 1; i <= 3; i++)
            {
              Pagine.PagineVisibili.push(i)
            }
          }
        }
        else
        {
          for(let i = 1; i <= Pagine.NumeroPagine; i++)
          {
            Pagine.PagineVisibili.push(i)
          }
        }
        if (Pagine.PagineVisibili.length < 2)
          Pagine.PagineVisibili = []
      },

      OnClickEliminaSito(sito)
      {
        this.SitoSelezionato = sito
        this.DescrizionePopup = this.GetTraduzioneLabel('VUEAppContentGestioneSiti','TKN_APP_CON_GEST_SIT_ALERT',this.LinguaUtente) + ' ' + this.SitoSelezionato.NOME + '?'
        this.PopupEliminaSito = true
      },

      ConfermaElimina()
      {
        let ObjQuery = {Operazioni : []}
        let Self = this
        ObjQuery.Operazioni.push(
                        {
                          Query : 'Delete',
                          Parametri : {CHIAVE: this.SitoSelezionato.CHIAVE}
                       })
        SystemInformation.AdvQuery.PostSQL('Admin_Siti', ObjQuery, function(){
                                                                                if (Self.SitoSelezionato.ALLEGATO != null && Self.SitoSelezionato.ALLEGATO != undefined)
                                                                                {
                                                                                  let Posizione = Self.SitoSelezionato.ALLEGATO.split(";")[1]
                                                                                  let LsAttachmentDaEliminare = []
                                                                                  LsAttachmentDaEliminare.push(Posizione)
                                                                                  SystemInformation.AdvQuery.DeleteAttachment(LsAttachmentDaEliminare,
                                                                                                                function()
                                                                                                                {
                                                                                                                  Self.VisualizzaSiti(1, true)
                                                                                                                  SystemInformation.GetConfigurazioni()
                                                                                                                  Self.PopupEliminaSito = false
                                                                                                                },
                                                                                                                SystemInformation.HandleError)                                                                                  
                                                                                }
                                                                                else
                                                                                {
                                                                                  Self.VisualizzaSiti(1, true)
                                                                                  Self.PopupEliminaSito = false
                                                                                  SystemInformation.GetConfigurazioni()
                                                                                }
                                                                              }, SystemInformation.HandleError)
      },

      AnnullaElimina()
      {
        this.PopupEliminaSito = false
      },

      OnClickApriSito(IdSito)
      {
        TemporaryGlobals.TmpNumber = this.ObjPagine.Pagina
        this.$router.push('/appMainWindow/Sito?Sito=' + IdSito)
      },      

      GetStyleAzioni()
      {
        if (this.Admin)
          return {'margin-right' : '20px', 'color': this.Giallo}
        return {'text-align' : 'center', 'color': this.Giallo}
      }
    },
    beforeMount()
    {
      this.Admin = RUOLI.Amministratore == SystemInformation.UserInformation.Ruolo
      if(TemporaryGlobals.TmpNumber != -1)
        this.VisualizzaSiti(TemporaryGlobals.TmpNumber, true)
      else this.VisualizzaSiti(1, true)
    },
}
</script>